import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Title from "../../Title/Title";
import { fileURL, useFetch, usePOST } from "../../../ApiS";
import { Bounce, toast, ToastContainer } from "react-toastify";
import PasswordInput from "../../Inputs/Passwordinput";
import AddImage from "../../../ApiS/AddImage/AddImage";
import { useEffect, useRef, useState } from "react";
import Loader from "../../Loader";
import { AiFillEdit } from "react-icons/ai";
import { FaCheck, FaEdit, FaTrash, FaTrashAlt } from "react-icons/fa";
import { MdAddCircleOutline } from "react-icons/md";
import Selected from "../../Inputs/Selected";
import { AxiosError } from "axios";
import { Tooltip } from "react-tooltip";
import Select, { MultiValue, SingleValue } from "react-select";

type SelectedOption = {
  value: string;
  label: string;
};

interface Semester {
  id?: string | number;
  name?: string;
  year?: string;
  start_date?: string;
  end_date?: string;
  registration_start_date?: string;
  registration_end_date?: string;
  has_exception?: boolean;
  max_fail_regular?: number;
  max_fail_dropout?: number;
  count_curriculums_optional?: number;
  count_curriculums_mandatory?: number;
  curriculums?: Curriculums[];
  discounts?: Discount[];
}

interface SemestersData {
  data: Semester;
}
interface Curriculums {
  ids?: number;
  code?: string;
  name_en?: string;
  name_ar?: string;
  min_pass_mark?: string;
  theoretical_mark?: string;
  practical_mark?: string;
  assistances_marks?: string;
  type?: string;
  is_optional?: string;
  in_program?: string;
  description_file?: string;
  id?: string | number;
  name?: string;
  year?: string;
  start_date?: string;
  end_date?: string;
  registration_start_date?: string;
  registration_end_date?: string;
  has_exception?: boolean;
  max_fail_regular?: number;
  max_fail_dropout?: number;
  count_curriculums_optional?: number;
  count_curriculums_mandatory?: number;
}

interface Error {
  ids?: string[];
  code?: string[];
  name_en?: string[];
  name_ar?: string[];
  min_pass_mark?: string[];
  theoretical_mark?: string[];
  practical_mark?: string[];
  assistances_marks?: string[];
  type?: string[];
  is_optional?: string[];
  in_program?: string[];
  description_file?: string[];
  id?: string[];
  name?: string[];
  year?: string[];
  start_date?: string[];
  end_date?: string[];
  registration_start_date?: string[];
  registration_end_date?: string[];
  has_exception?: string[];
  max_fail_regular?: string[];
  max_fail_dropout?: string[];
  count_curriculums_optional?: string[];
  count_curriculums_mandatory?: string[];
}

interface Discount {
  id: number;
  name: string;
  percentage: number;
  is_exhausted_student: boolean;
}

const Create_New_Discount: React.FC = () => {
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const enabled = id ? true : false;
  const { data, isLoading } = useFetch(
    `admin/semesters/${id}`,
    `semesters/${id}`,
    enabled
  );

  // let semData = data?.data;

  const [sem, setSem] = useState<Curriculums[]>([]);
  const [semData, setSemData] = useState<Curriculums>(data?.data!);
  const [errors, setErrors] = useState<Error>({});

  let dataOld = data?.data;

  const [Popup, setPopup] = useState(0);

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const {
    mutation,
    handleChangeInput,
    handleChangeArrayFiles,
    handleSubmit,
    setFormData,
    formData,
    viewFile,
    setViewFile,
    setViewFiles,
    files,
    viewFiles,
    handleChangeSelect,
    handleChangeMultiSelect
  } = usePOST(
    { _method: id ? "PUT" : "POST" },
    () => {
      navigate("/new_semester");
    },
    (error) => {
      onError(error);
    }
  );
  const prepareFormData = () => {
    const formattedOptions = sem.reduce((acc, sem, index) => {
      return {
        ...acc,
        [`curriculums[${index}][code]`]: sem?.code,
        [`curriculums[${index}][name_en]`]: sem?.name_en,
        [`curriculums[${index}][name_ar]`]: sem?.name_ar,
        [`curriculums[${index}][min_pass_mark]`]: sem?.min_pass_mark,
        [`curriculums[${index}][theoretical_mark]`]: sem?.theoretical_mark,
        [`curriculums[${index}][practical_mark]`]: sem?.practical_mark,
        [`curriculums[${index}][assistances_marks]`]: sem?.assistances_marks,
        [`curriculums[${index}][type]`]: sem?.type,
        [`curriculums[${index}][is_optional]`]: sem?.is_optional,
        [`curriculums[${index}][in_program]`]: sem?.in_program,
        [`curriculums[${index}][description_file]`]: sem?.description_file,
      };
    }, {});
    const finalData = {
      ...formattedOptions,
      ...formData,
      _method: id ? "PUT" : "POST",
    };

    setFormData(finalData);
  };

  const [editIndex, setEditIndex] = useState<number | null>(null);

  useEffect(() => {
    prepareFormData();
  }, [sem]);

  const handleSave = () => {
    // التحقق من ملء الحقول المطلوبة
    if (
      !semData?.code ||
      !semData?.name_ar ||
      !semData?.name_en ||
      !semData?.min_pass_mark ||
      !semData?.theoretical_mark ||
      !semData?.practical_mark ||
      !semData?.assistances_marks ||
      !semData?.type ||
      !semData?.is_optional ||
      !semData?.in_program
    ) {
      toast.error("يرجى ملء جميع الحقول المطلوبة");
      return;
    }
  
    let updatedSem = [...sem]; // نسخ القائمة القديمة لـ sem
    let updatedFormData = { ...formData }; // نسخ formData القديمة
  
    if (editIndex !== null) {
      // إذا كان يتم تعديل عنصر موجود
      updatedSem[editIndex] = { ...sem[editIndex], ...semData };
  
      // استبدال القيم القديمة في formData بالقيم الجديدة من semData
      updatedFormData = {
        ...updatedFormData,
        [`curriculums[${editIndex}][code]`]: semData.code,
        [`curriculums[${editIndex}][name_ar]`]: semData.name_ar,
        [`curriculums[${editIndex}][name_en]`]: semData.name_en,
        [`curriculums[${editIndex}][min_pass_mark]`]: semData.min_pass_mark,
        [`curriculums[${editIndex}][theoretical_mark]`]: semData.theoretical_mark,
        [`curriculums[${editIndex}][practical_mark]`]: semData.practical_mark,
        [`curriculums[${editIndex}][assistances_marks]`]: semData.assistances_marks,
        [`curriculums[${editIndex}][type]`]: semData.type,
        [`curriculums[${editIndex}][is_optional]`]: semData.is_optional,
        [`curriculums[${editIndex}][in_program]`]: semData.in_program,
        [`curriculums[${editIndex}][description_file]`]: semData.description_file,
      };
  
      setSem(updatedSem); // تحديث قائمة المقررات
      setFormData(updatedFormData); // تحديث formData بالقيم المعدلة
      toast.success("تم التحديث بنجاح");
    } else {
      // إذا كان إدخال جديد
      setSem((prev) => [...prev, semData]);
      updatedFormData = {
        ...updatedFormData,
        [`curriculums[${sem.length}][code]`]: semData.code,
        [`curriculums[${sem.length}][name_ar]`]: semData.name_ar,
        [`curriculums[${sem.length}][name_en]`]: semData.name_en,
        [`curriculums[${sem.length}][min_pass_mark]`]: semData.min_pass_mark,
        [`curriculums[${sem.length}][theoretical_mark]`]: semData.theoretical_mark,
        [`curriculums[${sem.length}][practical_mark]`]: semData.practical_mark,
        [`curriculums[${sem.length}][assistances_marks]`]: semData.assistances_marks,
        [`curriculums[${sem.length}][type]`]: semData.type,
        [`curriculums[${sem.length}][is_optional]`]: semData.is_optional,
        [`curriculums[${sem.length}][in_program]`]: semData.in_program,
        [`curriculums[${sem.length}][description_file]`]: semData.description_file,
      };
  
      setFormData(updatedFormData); // تحديث formData بالقيم الجديدة
      toast.success("تم الحفظ بنجاح");
    }
  
    // إعادة تعيين الحقول بعد الحفظ أو التعديل
    setSemData({
      code: "",
      name_ar: "",
      name_en: "",
      min_pass_mark: "",
      theoretical_mark: "",
      practical_mark: "",
      assistances_marks: "",
      type: "",
      is_optional: "",
      in_program: "",
      description_file: "",
    });
  
    setEditIndex(null);
  };
  
  const [isEditing, setIsEditing] = useState(false);
  const handleEdit = (index: number) => {
    setEditIndex(index);
    setSemData(sem[index]);
    setIsEditing(true);
  };

  const handleDelete = (index: number) => {
    const updatedSem = sem.filter((_, i) => i !== index);
    setSem(updatedSem);
    toast.success("تم الحذف بنجاح");
  };

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: id ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);


  const { data: curriculums } = useFetch(
    "admin/curriculums?page=0",
    "admin/curriculums"
  );

  

  const curriculum = curriculums?.data?.data?.map((e: any) => ({
    value: e.id,
    label: e.name_ar,
  }));

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Col lg={4} md={4}>
          <Title title={id ? "تعديل  الفصول" : "أنشاء  الفصول"} />
        </Col>
      </Row>
      <ToastContainer position="bottom-left" />

      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="name"
            onChange={handleChangeInput}
            title="الأسم "
            placeholder="أدخل الأسم "
            className="!w-full"
            defaultValue={dataOld?.name}
          />
          {errors?.name &&
            errors?.name.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="year"
            onChange={handleChangeInput}
            title="النسبة"
            placeholder="ادخل النسبة"
            className="!w-full"
            defaultValue={dataOld?.year}
          />
          {errors?.year &&
            errors?.year.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="start_date"
            onChange={handleChangeInput}
            title="تاريخ البداية"
            placeholder="ادخل تاريخ البداية"
            className="!w-full"
            defaultValue={dataOld?.start_date}
          />
          {errors?.start_date &&
            errors?.start_date.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="end_date"
            onChange={handleChangeInput}
            title="تاريخ النهاية"
            placeholder="ادخل تاريخ النهاية"
            className="!w-full"
            defaultValue={dataOld?.end_date}
          />
          {errors?.end_date &&
            errors?.end_date.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="registration_start_date"
            onChange={handleChangeInput}
            title="تاريخ بداية التسجيل"
            placeholder="ادخل تاريخ بداية التسجيل"
            className="!w-full"
            defaultValue={dataOld?.registration_start_date}
          />
          {errors?.registration_start_date &&
            errors?.registration_start_date.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="registration_end_date"
            onChange={handleChangeInput}
            title="تاريخ نهاية التسجيل"
            placeholder="ادخل تاريخ نهاية التسجيل"
            className="!w-full"
            defaultValue={dataOld?.registration_end_date}
          />
          {errors?.registration_end_date &&
            errors?.registration_end_date.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <div className=" border-2 border-Main text-l lg:mt-11 flex items-center justify-center py-2 rounded-2xl gap-2 !w-[97%]">
            <input
              type="checkbox"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  has_exception: e.target.checked ? 1 : 0,
                }))
              }
              name="has_exception"
              className="relative w-5 h-5"
              defaultChecked={dataOld?.has_exception}
            />
            <span className="text-xl font-bold text-yellow-700 ">استثناء</span>
          </div>
          {errors?.has_exception &&
            errors?.has_exception.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="max_fail_regular"
            onChange={handleChangeInput}
            title=" الحد الأقصى للفشل المنتظم"
            placeholder="ادخل  الحد الأقصى للفشل المنتظم"
            className="!w-full"
            defaultValue={dataOld?.max_fail_regular}
          />
          {errors?.max_fail_regular &&
            errors?.max_fail_regular.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="max_fail_dropout"
            onChange={handleChangeInput}
            title=" الحد الأقصى للفشل في التسرب"
            placeholder="ادخل  الحد الأقصى للفشل في التسرب"
            className="!w-full"
            defaultValue={dataOld?.max_fail_dropout}
          />
          {errors?.max_fail_dropout &&
            errors?.max_fail_dropout.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="count_curriculums_optional"
            onChange={handleChangeInput}
            title="عدد المناهج الاختيارية"
            placeholder="ادخل عدد المناهج الاختيارية"
            className="!w-full"
            defaultValue={dataOld?.count_curriculums_optional}
          />
          {errors?.count_curriculums_optional &&
            errors?.count_curriculums_optional.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="count_curriculums_mandatory"
            onChange={handleChangeInput}
            title="عدد المناهج الاجبارية"
            placeholder="ادخل عدد المناهج الاجبارية"
            className="!w-full"
            defaultValue={dataOld?.count_curriculums_mandatory}
          />
          {errors?.count_curriculums_mandatory &&
            errors?.count_curriculums_mandatory.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
        <Select
            name="curriculum_ids"
            options={curriculum}
            onChange={(selectedOption) =>
              handleChangeMultiSelect(
                selectedOption as
                  | SingleValue<SelectedOption>
                  | MultiValue<SelectedOption>,
                { name: "curriculum_ids" }
              )
            }
            placeholder="Select an option"
            className="w-full border-none mt-11 p-2  shadow-3 shadow-Secondary outline-none m-1 rounded-2xl text-start"
            isClearable
            isMulti
          />
        </Col>
      </Row>
      <Row justify="around">
        <Col lg={5} md={5} sm={11}>
          <MainButton
            titlebtn="أضف المقررات"
            className="w-full "
            onClick={() => setPopup(1)}
          />
          {sem?.length > 0 ? (
            <button
              className="underline text-red-600"
              onClick={() => setPopup(15)}
            >
              عرض المقررات المدخلة{" "}
            </button>
          ) : <p>لا يوجد مقررات مدخلة</p>}
        </Col>

        <Col lg={5} md={5} sm={11} className=" " onClick={() => setPopup(3)}>
          <MainButton
            titlebtn="اضافة حسومات"
            className="w-full !border-2 !border-Secondary !bg-white !text-Secondary hover:!bg-Secondary hover:!text-white  "
          />
        </Col>
      </Row>
      <Row justify="around">
        <Col lg={5} md={5} sm={11} className="" onClick={() => setPopup(4)}>
          <MainButton titlebtn="الرسوم الدراسية" className="w-full" />
        </Col>
        <Col lg={5} md={5} sm={11} className="" onClick={() => setPopup(5)}>
          <MainButton
            titlebtn="رسوم الخدمات"
            className="w-full !border-2 !border-Secondary !bg-white !text-Secondary hover:!bg-Secondary hover:!text-white"
          />
        </Col>
      </Row>
      <Row justify="around">
        <Col lg={5} md={5} sm={11} className="" onClick={() => setPopup(6)}>
          {/* <MainButton titlebtn="اعادة الطلاب المستنفذين" className="w-full" /> */}
          <MainButton titlebtn="شرط الترفع" className="w-full" />
        </Col>
        <Col lg={5} md={5} sm={11} className="" onClick={() => setPopup(7)}>
          <MainButton
            titlebtn="القاعات الامتحانية"
            className="w-full !border-2 !border-Secondary !bg-white !text-Secondary hover:!bg-Secondary hover:!text-white"
          />
        </Col>
      </Row>
      <Row justify="around">
        <Col lg={5} md={5} sm={11} className="" onClick={() => setPopup(8)}>
          <MainButton titlebtn="البرنامج الامتحاني" className="w-full" />
        </Col>
        <Col lg={5} md={5} sm={11} className="" onClick={() => setPopup(9)}>
          {/* <MainButton
            titlebtn="شرط الترفع"
            className="w-full !border-2 !border-Secondary !bg-white !text-Secondary hover:!bg-Secondary hover:!text-white"
          /> */}
        </Col>
      </Row>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
      >
        <MainButton
          onClick={() =>
            handleSubmit(id ? `admin/semesters/${id}` : `admin/semesters`)
          }
          titlebtn="انشاء"
          className="w-[400px] "
        />
      </Col>

      {Popup === 1 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[40%] max-lg:w-[80%] max-md:w-full bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} sm={8} className="flex justify-center !mt-2">
                <Title title=" انشاء فصل دراسي جديد" />
              </Col>

              <Col
                lg={10}
                sm={12}
                md={8}
                className="border flex justify-start items-center p-2 !mt-3 rounded-lg cursor-pointer"
                onClick={() => setPopup(2)}
              >
                <div className="border rounded-full mx-5 p-3 bg-Main">
                  <MdAddCircleOutline size={25} className="text-Secondary" />
                </div>

                <div className="mx-5 text-lg max-md:text-base">
                  {" "}
                  ادراج مقرر دراسي{" "}
                </div>
              </Col>

              {/* <Col
                lg={10}
                sm={12}
                md={8}
                className="border flex justify-start items-center p-2 !mt-5 rounded-lg"
              >
                <div className="border rounded-full mx-5 p-3 bg-Main">
                  <AiFillEdit size={20} className="text-Secondary" />
                </div>

                <div className="mx-5 text-lg max-md:text-base">
                  {" "}
                  تعديل مقرر دراسي{" "}
                </div>
              </Col> */}

              {/* <Col
                lg={10}
                sm={12}
                md={8}
                className="border flex justify-start items-center p-2 !mt-5 rounded-lg"
              >
                <div className="border rounded-full mx-5 p-3 bg-Main">
                  <FaTrashAlt size={20} className="text-Secondary" />
                </div>

                <div className="mx-5 text-lg max-md:text-base">
                  {" "}
                  حذف مقرر دراسي{" "}
                </div>
              </Col> */}
            </Row>
          </Col>
        </Row>
      )}

      {/* -------------------------------------------------------PopUp---------------------------------------------------------------------------- */}

      {Popup === 2 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh]  w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full h-[80%] overflow-y-scroll bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="قم بادخال معلومات المقررات" />
              </Col>

              {id ? (
                dataOld?.curriculums?.map((e: any) => (
                  <>
                    <Col lg={5} className=" ">
                      <Input
                        type="text"
                        name="code"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            code: e.target.value,
                          }))
                        }
                        title="رمز المقرر"
                        placeholder="أدخل رمز المقرر "
                        className="!w-full"
                        defaultValue={e?.code || ""}
                      />
                      {errors?.code &&
                        errors?.code.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="text"
                        name="name_ar"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            name_ar: e.target.value,
                          }))
                        }
                        title=" اسم المقرر باللغة العربية"
                        placeholder=" اسم المقرر باللغة العربية"
                        className="!w-full"
                        defaultValue={e?.name_ar || ""}
                      />
                      {errors?.name_ar &&
                        errors?.name_ar.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="text"
                        name="name_en"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            name_en: e.target.value,
                          }))
                        }
                        title="اسم المقرر باللغة الأنكليزية"
                        placeholder="اسم المقرر باللغة الأنكليزية"
                        className="!w-full"
                        defaultValue={e?.name_en || ""}
                      />
                      {errors?.name_en &&
                        errors?.name_en.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="number"
                        name="min_pass_mark"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            min_pass_mark: e.target.value,
                          }))
                        }
                        title="الحد الادنى لعلامة النجاح"
                        placeholder="الحد الادنى لعلامة النجاح"
                        className="!w-full"
                        defaultValue={e?.min_pass_mark || ""}
                      />
                      {errors?.min_pass_mark &&
                        errors?.min_pass_mark.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="number"
                        name="practical_mark"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            practical_mark: e.target.value,
                          }))
                        }
                        title="علامة العملي "
                        placeholder="علامة العملي "
                        className="!w-full"
                        defaultValue={e?.practical_mark || ""}
                      />
                      {errors?.practical_mark &&
                        errors?.practical_mark.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="number"
                        name="theoretical_mark"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            theoretical_mark: e.target.value,
                          }))
                        }
                        title="علامة النظري "
                        placeholder="علامة النظري "
                        className="!w-full"
                        defaultValue={e?.theoretical_mark || ""}
                      />
                      {errors?.theoretical_mark &&
                        errors?.theoretical_mark.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="number"
                        name="assistances_marks"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            assistances_marks: e.target.value,
                          }))
                        }
                        title="علامة المساعدة "
                        placeholder="علامة المساعدة "
                        className="!w-full"
                        defaultValue={e?.assistances_marks || ""}
                      />
                      {errors?.assistances_marks &&
                        errors?.assistances_marks.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Selected
                        text="حالة المقرر"
                        title="حالة المقرر"
                        name="is_optional"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            is_optional: e.target.value,
                          }))
                        }
                        defaultValue={e?.is_optional || ""}
                      >
                        <option value="" selected hidden disabled>
                          حالة المقرر
                        </option>
                        <option value="1">اختياري</option>
                        <option value="0">اجباري</option>
                      </Selected>
                      {errors?.is_optional &&
                        errors?.is_optional.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Selected
                        text=" في البرنامج "
                        title=" في البرنامج "
                        name="in_program"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            in_program: e.target.value,
                          }))
                        }
                        defaultValue={e?.in_program || ""}
                      >
                        <option value="" selected hidden disabled>
                          {" "}
                          في البرنامج{" "}
                        </option>

                        <option value="1">نعم</option>
                        <option value="0">لا</option>
                      </Selected>
                      {errors?.in_program &&
                        errors?.in_program.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Selected
                        text="نمط المقرر"
                        title="نمط المقرر"
                        name="type"
                        onChange={(e) =>
                          setSemData((prev) => ({
                            ...prev,
                            type: e.target.value,
                          }))
                        }
                        defaultValue={e.type || ""}
                      >
                        <option value="" disabled selected hidden>
                          نمط المقرر
                        </option>
                        <option value="traditional">تقليدي</option>
                        <option value="automated">أتمتة</option>
                      </Selected>
                      {errors?.type &&
                        errors?.type.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <AddImage
                        type="PDF"
                        id="description_file"
                        title=" ملف الوصف "
                        name="description_file"
                        onChange={(event) => {
                          setSemData((prev) => ({
                            ...prev,
                            description_file: event.target.value,
                          }));

                          handleChangeInput(event, "description_file");
                        }}
                        oldImage={e.description_file}
                        newPDF={viewFile["description_file"]?.pdf}
                        clickDeletePDF={() => {
                          setViewFile((prev) => ({
                            ...prev,
                            description_file: { pdf: "" },
                          }));
                          setSemData((prev) => ({
                            ...prev,
                            description_file: "",
                          }));
                        }}
                        // clickDeleteOldImage={() => {
                        //   setImage_1(null);
                        // }}
                      />
                      {errors?.description_file &&
                        errors?.description_file.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                  </>
                ))
              ) : (
                <>
                  <Col lg={5} className=" ">
                    <Input
                      type="text"
                      name="code"
                      value={semData?.code || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          code: e.target.value,
                        }))
                      }
                      title="رمز المقرر"
                      placeholder="أدخل رمز المقرر "
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Input
                      type="text"
                      name="name_ar"
                      value={semData?.name_ar || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          name_ar: e.target.value,
                        }))
                      }
                      title=" اسم المقرر باللغة العربية"
                      placeholder=" اسم المقرر باللغة العربية"
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Input
                      type="text"
                      name="name_en"
                      value={semData?.name_en || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          name_en: e.target.value,
                        }))
                      }
                      title="اسم المقرر باللغة الأنكليزية"
                      placeholder="اسم المقرر باللغة الأنكليزية"
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Input
                      type="number"
                      name="min_pass_mark"
                      value={semData?.min_pass_mark || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          min_pass_mark: e.target.value,
                        }))
                      }
                      title="الحد الادنى لعلامة النجاح"
                      placeholder="الحد الادنى لعلامة النجاح"
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Input
                      type="number"
                      name="practical_mark"
                      value={semData?.practical_mark || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          practical_mark: e.target.value,
                        }))
                      }
                      title="علامة العملي "
                      placeholder="علامة العملي "
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Input
                      type="number"
                      name="theoretical_mark"
                      value={semData?.theoretical_mark || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          theoretical_mark: e.target.value,
                        }))
                      }
                      title="علامة النظري "
                      placeholder="علامة النظري "
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Input
                      type="number"
                      name="assistances_marks"
                      value={semData?.assistances_marks || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          assistances_marks: e.target.value,
                        }))
                      }
                      title="علامة المساعدة "
                      placeholder="علامة المساعدة "
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} className=" ">
                    <Selected
                      text="حالة المقرر"
                      title="حالة المقرر"
                      name="is_optional"
                      value={semData?.is_optional || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          is_optional: e.target.value,
                        }))
                      }
                    >
                      <option value="" selected hidden disabled>
                        حالة المقرر
                      </option>

                      <option value="1">اختياري</option>
                      <option value="0">اجباري</option>
                    </Selected>
                  </Col>
                  <Col lg={5} className=" ">
                    <Selected
                      text=" في البرنامج "
                      title=" في البرنامج "
                      name="in_program"
                      value={semData?.in_program || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          in_program: e.target.value,
                        }))
                      }
                    >
                      <option value="" selected hidden disabled>
                        {" "}
                        في البرنامج{" "}
                      </option>

                      <option value="1">نعم</option>
                      <option value="0">لا</option>
                    </Selected>
                  </Col>
                  <Col lg={5} className=" ">
                    <Selected
                      text="نمط المقرر"
                      title="نمط المقرر"
                      name="type"
                      value={semData?.type || ""}
                      onChange={(e) =>
                        setSemData((prev) => ({
                          ...prev,
                          type: e.target.value,
                        }))
                      }
                    >
                      <option value="" hidden disabled selected>
                        نمط المقرر
                      </option>
                      <option value="traditional">تقليدي</option>
                      <option value="automated">أتمتة</option>
                    </Selected>
                  </Col>
                  <Col lg={5} className="lg:!mt-5">
                    <h1>ملف الوصف</h1>
                    <AddImage
                      type="PDF"
                      value={semData?.description_file || ""}
                      id="description_file"
                      title=" ملف الوصف "
                      name="description_file"
                      onChange={(event) => {
                        setSemData((prev) => ({
                          ...prev,
                          description_file: event.target.value,
                        }));
                        handleChangeInput(event, "description_file");
                      }}
                      // oldImage={image_1}
                      newImage={viewFile["description_file"]?.pdf}
                      clickDeletePDF={() => {
                        setViewFile((prev) => ({
                          ...prev,
                          description_file: { image: "" },
                        }));
                        setSemData((prev) => ({
                          ...prev,
                          description_file: "",
                        }));
                      }}
                      // clickDeleteOldImage={() => {
                      //   setImage_1(null);
                      // }}
                    />
                  </Col>
                  <Col lg={5} className=" "></Col>
                </>
              )}

              <Col lg={5} sm={6} className="!mt-3 ">
                <MainButton
                  titlebtn="ادراج"
                  className="!w-full"
                  onClick={handleSave}
                />
              </Col>
              <Col lg={5} sm={6} className="!mt-3 " onClick={() => setPopup(1)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 3 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[40%] max-lg:w-[80%] max-md:w-full bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title=" اضافة حسومات" />
              </Col>

              <Col lg={10} className=" ">
                <Input placeholder="اسم الحسم" />
              </Col>
              <Col lg={10} className=" ">
                <Input placeholder="نسبة الحسم" />
              </Col>
              <Col lg={10} className=" ">
                <Input placeholder="شرط الحسم" />
              </Col>
              <Col lg={5} sm={6} className="!mt-2">
                <MainButton titlebtn="اضافة" className="!w-full" />
              </Col>
              <Col lg={5} sm={6} className="!mt-2" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 4 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full  bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title=" الرسوم الدراسية" />
              </Col>

              <Col lg={5} className=" ">
                <Input placeholder=" رمز المقرر" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder=" سنة التسجيل" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder=" قيمة الرسم" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder="عدد مرات التسجيل" />
              </Col>
              <Col lg={5} sm={5} className="flex justify-end ">
                <div className="flex items-center ">
                  <Input type="radio" id="rad" className="" name="check2" />
                  <p className="mt-1 mx-4 text-base">مستنفذ</p>
                </div>
              </Col>
              <Col lg={5} sm={7} className=" ">
                <div className="flex items-center ">
                  <Input type="radio" id="rad" className="" name="check2" />
                  <p className="mt-1 mx-4 text-base">غير مستنفذ</p>
                </div>
              </Col>
              <Col lg={5} sm={6} className="!mt-2">
                <MainButton titlebtn="اضافة" className="!w-full" />
              </Col>
              <Col lg={5} sm={6} className="!mt-2" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 5 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full max-lg:h-[70%] max-lg:overflow-y-scroll bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="رسوم الخدمات الجامعية" />
              </Col>

              <Col lg={5} md={5} className=" ">
                <Input placeholder="اسم الخدمة" />
              </Col>
              <Col lg={5} md={5} className=" ">
                <Input placeholder="رسم الخدمة" />
              </Col>
              <Col lg={5} md={5} className=" ">
                <Input placeholder="رسوم الطوابع" />
              </Col>
              <Col lg={5} md={5} className=" ">
                <Input placeholder="نوع الحسم" />
              </Col>
              <Col lg={5} md={5} className=" ">
                <Input placeholder="نسبة الحسم" />
              </Col>
              <Col lg={5} md={5} className=" "></Col>

              <Col lg={5} sm={6} className="!mt-2">
                <MainButton titlebtn="اضافة" className="!w-full" />
              </Col>
              <Col lg={5} sm={6} className="!mt-2" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {Popup === 6 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title=" اعادة الطلاب المستنفذين " />
              </Col>

              <Col lg={5} md={6} className=" ">
                <Input placeholder="اسم الفصل" />
              </Col>
              <Col lg={5} md={6} className=" ">
                <Input placeholder=" عدد الفصول الدراسية التي منحهم اياها" />
              </Col>
              <Col lg={5} md={6} className=" ">
                <Input placeholder=" رقم المرسوم" />
              </Col>
              <Col lg={5} md={6} className="!mt-1">
                {/* <AddImage
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  title="صورة المرسوم"
                  name="file"
                  className="!bg-Main w-full h-12  "
                  onChange={(e) => {
                    setSuccessPost(0);
                    handleChangeInput(e);
                  }}
                /> */}
              </Col>
              <Col lg={5} sm={6} className="!mt-2">
                <MainButton titlebtn="اضافة" className="!w-full" />
              </Col>
              <Col lg={5} sm={6} className="!mt-2" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 7 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="القاعات الامتحانية" />
              </Col>

              <Col lg={10} className=" ">
                <Input placeholder="اسم القاعة" />
              </Col>
              <Col lg={10} className=" ">
                <Input placeholder="مكان القاعة" />
              </Col>
              <Col lg={10} className=" ">
                <Input placeholder="السعة الافتراضية" />
              </Col>

              <Col lg={5} sm={6} className="!mt-3">
                <MainButton titlebtn="اضافة" className="!w-full" />
              </Col>
              <Col lg={5} sm={6} className="!mt-3" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 8 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full max-lg:h-[70%] max-lg:overflow-y-scroll bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="البرنامج الامتحاني" />
              </Col>

              <Col lg={5} className=" ">
                <Input placeholder="رمز المقرر" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder=" اسم المقرر" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder=" تاريخ الامتحان" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder=" ساعة البدء" />
              </Col>
              <Col lg={5} className=" ">
                <Input placeholder="ساعة الانتهاء" />
              </Col>
              <Col lg={5} className=" "></Col>

              <Col lg={5} sm={6} className="!mt-2">
                <MainButton titlebtn="اضافة" className="!w-full" />
              </Col>
              <Col lg={5} sm={6} className="!mt-2" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 9 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full max-lg:h-[70%] max-lg:overflow-y-scroll bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute cursor-pointer   hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setPopup(0)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title=" شرط الترفع" />
              </Col>

              <Col lg={12} sm={12} className="!mt-5">
                <div className="flex w-full text-base ">
                  يترفع الطالب من سنة لأعلى في حال رسوبه في{" "}
                  <input
                    placeholder="اكتب هنا"
                    className="w-24 border border-Secondary rounded-2xl !mx-3"
                  />{" "}
                  مقررات على الأكثر
                </div>
              </Col>

              <Col lg={12} sm={12} className="!mt-5">
                <div className="text-Secondary text-lg ">
                  في حال لم يكن الطالب منقطع عن الدراسة
                </div>
              </Col>

              <Col lg={12} sm={12} className="!mt-5">
                <div className="flex w-full text-base">
                  يترفع الطالب من سنة لأعلى في حال رسوبه في{" "}
                  <input
                    placeholder="اكتب هنا"
                    className="w-24 border border-Secondary rounded-2xl !mx-3"
                  />{" "}
                  مقررات على الأكثر
                </div>
              </Col>

              <Col lg={5} md={6} className="!mt-7">
                <MainButton titlebtn="حفظ" className="!w-full" />
              </Col>
              <Col lg={5} md={6} className="!mt-7" onClick={() => setPopup(0)}>
                <MainButton
                  titlebtn="الغاء"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {Popup === 15 && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold !bg-black !bg-opacity-50"
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full  h-[80%] overflow-y-scroll bg-white p-5 border-2 rounded-xl"
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => {
                  setPopup(0);
                  setIsEditing(false);
                }}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>
              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="المقررات المدخلة" />
              </Col>

              <Col lg={12} sm={12} className="">
                {sem.map((e, index) => (
                  <div
                    key={index}
                    className="flex p-5 border-2 border-black rounded-2xl my-5"
                  >
                    <Row justify="around">
                      <Col lg={10}>
                        <div className="flex justify-end">
                          <div id="Delete">
                            <FaTrash
                              size={25}
                              className="text-red-600 cursor-pointer hover:text-red-800 mx-10"
                              onClick={() => handleDelete(index)}
                            />
                          </div>
                          <div id="Edit">
                            {isEditing ? (
                              <FaCheck
                                size={25}
                                className="text-blue-600 cursor-pointer hover:text-green-800"
                              />
                            ) : (
                              <FaEdit
                                size={25}
                                className="text-blue-600 cursor-pointer hover:text-blue-800"
                                onClick={() => handleEdit(index)}
                              />
                            )}
                          </div>
                          <Tooltip
                            anchorSelect={`#Edit`}
                            style={{ background: "#475569" }}
                          >
                            <p>تمكين التعديل</p>
                          </Tooltip>
                          <Tooltip
                            anchorSelect={`#Delete`}
                            style={{ background: "#475569" }}
                          >
                            <p>حذف المقرر</p>
                          </Tooltip>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="text"
                          name="code"
                          title="رمز المقرر"
                          placeholder="رمز المقرر"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.code || ""
                              : e.code || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              code: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="text"
                          name="name_ar"
                          title="اسم المقرر باللغة العربية"
                          placeholder="اسم المقرر باللغة العربية"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.name_ar || ""
                              : e.name_ar || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              name_ar: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="text"
                          name="name_en"
                          title="اسم المقرر باللغة الإنجليزية"
                          placeholder="اسم المقرر باللغة الإنجليزية"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.name_en || ""
                              : e.name_en || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              name_en: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="number"
                          name="min_pass_mark"
                          title="الحد الأدنى لعلامة النجاح"
                          placeholder="الحد الأدنى لعلامة النجاح"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.min_pass_mark || ""
                              : e.min_pass_mark || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              min_pass_mark: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="number"
                          name="theoretical_mark"
                          title="علامة النظري"
                          placeholder="علامة النظري"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.theoretical_mark || ""
                              : e.theoretical_mark || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              theoretical_mark: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="number"
                          name="practical_mark"
                          title="علامة العملي"
                          placeholder="علامة العملي"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.practical_mark || ""
                              : e.practical_mark || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              practical_mark: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Input
                          type="number"
                          name="assistances_marks"
                          title="علامة المساعدة"
                          placeholder="علامة المساعدة"
                          className="!w-full"
                          value={
                            editIndex === index
                              ? semData.assistances_marks || ""
                              : e.assistances_marks || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              assistances_marks: event.target.value,
                            }))
                          }
                        />
                      </Col>
                      <Col lg={5}>
                        <Selected
                          name="is_optional"
                          title="حالة المقرر"
                          value={
                            editIndex === index
                              ? semData.is_optional || ""
                              : e.is_optional || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              is_optional: event.target.value,
                            }))
                          }
                        >
                          <option value="" disabled hidden>
                            حالة المقرر
                          </option>
                          <option value="1">اختياري</option>
                          <option value="0">اجباري</option>
                        </Selected>
                      </Col>
                      <Col lg={5}>
                        <Selected
                          name="in_program"
                          title="في البرنامج"
                          value={
                            editIndex === index
                              ? semData.in_program || ""
                              : e.in_program || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              in_program: event.target.value,
                            }))
                          }
                        >
                          <option value="" disabled hidden>
                            في البرنامج
                          </option>
                          <option value="1">نعم</option>
                          <option value="0">لا</option>
                        </Selected>
                      </Col>
                      <Col lg={5}>
                        <Selected
                          name="type"
                          title="نمط المقرر"
                          value={
                            editIndex === index
                              ? semData.type || ""
                              : e.type || ""
                          }
                          onChange={(event) =>
                            setSemData((prev) => ({
                              ...prev,
                              type: event.target.value,
                            }))
                          }
                        >
                          <option value="" disabled hidden>
                            نمط المقرر
                          </option>
                          <option value="traditional">تقليدي</option>
                          <option value="automated">أتمتة</option>
                        </Selected>
                      </Col>
                      <Col lg={10}>
                        <h2 className="text-start text-sm font-bold mx-1 mt-3">
                          ملف الوصف
                        </h2>
                        <AddImage
                          type="PDF"
                          id="description_file"
                          title="ملف الوصف"
                          name="description_file"
                          oldPDF={
                            editIndex === index
                              ? semData.description_file
                              : e.description_file
                          }
                        />
                        <Col
                          lg={1}
                          className="flex items-center justify-center"
                        ></Col>
                      </Col>
                    </Row>
                  </div>
                ))}
              </Col>


              <Col lg={5} md={6} className="!mt-7">
                <MainButton
                  onClick={handleSave}
                  titlebtn="تحديث"
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
              <Col
                lg={5}
                md={6}
                className="!mt-7"
                onClick={() => setEditIndex(null)}
              >
                <MainButton
                  titlebtn="رجوع"
                  onClick={() => {
                    setPopup(0);
                    setIsEditing(false);
                  }}
                  className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Create_New_Discount;
